
@if (customerId != null) {
  <button class="gridbtn" mat-raised-button (click)="click()" title="Manage Subscription">
    @if (loading) {
      <mat-spinner diameter=25 strokeWidth=4></mat-spinner>
    }
    @if (!loading) {
      <span>Manage Billing</span>
    }
  </button>
}